import { render, staticRenderFns } from "./stuck_block.vue?vue&type=template&id=3017c862&"
import script from "./stuck_block.vue?vue&type=script&lang=js&"
export * from "./stuck_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports